import { type, deepCopy, debounce } from 'es-sharp'
export { type, deepCopy, debounce }

// Pixel
export function Pixel() {
    var args = [...arguments]

    // (x, y)
    if (args.length == 2) {
        return new AMap.Pixel(...args)
    }

    if (args.length == 1) {
        var pixel = args[0]

        // [x, y]
        if (type(pixel) == 'array') {
            return new AMap.Pixel(...pixel)
        }

        // {x, y}
        if (type(pixel) == 'object') {
            return new AMap.Pixel(pixel.x, pixel, y)
        }
    }

    return null
}
// Size
export function Size(size) {
    var args = [...arguments]

    // (width, height)
    if (args.length == 2) {
        return new AMap.Size(...args)
    }

    if (args.length == 1) {
        var size = args[0]

        // [width, height]
        if (type(size) == 'array') {
            return new AMap.Size(...size)
        }

        // {width, height}
        if (type(size) == 'object') {
            return new AMap.Size(size.width, size.height)
        }
    }

    return null
}
